import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TariffOptionConfiguration} from '../model/tariff-option-configuration';
import {FieldConfiguration} from '../model/field-configuration';
import {PricesWrapper} from '../model/prices-wrapper';
import {TariffConfigurationService} from "./tariff-configuration-service";

@Injectable({
  providedIn: 'root'
})
export class TariffDataApiService {

  public baseUrl = '';
  public product = '';

  private httpOptions = {
    headers: new HttpHeaders({
      'form-identifier': 'tariffdata'
    })
  };

  private httpClient: HttpClient;
  public lastErrors: any[] = [];

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async post(path: string, data: any): Promise<any> {
    return await this.httpClient.post(this.baseUrl + path, data, this.httpOptions).toPromise();
  }

  getFieldValueByKey(field: FieldConfiguration, key: string) {
    for (const option of field.options) {
      if (option.key === key) {
        return option.value;
      }
    }
    return '';
  }


  storeTariffData(tariffOptions: Map<string, TariffOptionConfiguration>, prices: Map<string, PricesWrapper>): Promise<void> {
    const configuration: any = {};

    let totalPriceUkv = 0;
    let totalPriceBk = 0;

    tariffOptions.forEach((toc: TariffOptionConfiguration, key: string) => {
      const pricesWrapper = prices.get(key);

      if (pricesWrapper) {
        configuration[key] = {
          enabled: toc.active,
          priceUkv: pricesWrapper.priceUkv,
          priceBk: pricesWrapper.priceBk,
          fields: {}
        };

        if (toc.active && key !== TariffConfigurationService.CALCULATION_ID_EMPLOYERS_CONTRIBUTION) {
          totalPriceUkv += pricesWrapper.priceUkv;
          totalPriceBk += pricesWrapper.priceBk;
        }
      }

      Object.keys(toc.fields).forEach((fieldKey) => {
        const field: FieldConfiguration = toc.fields[fieldKey] as FieldConfiguration;
        configuration[key].fields[fieldKey] = {
          value: this.getFieldValueByKey(field, field.value)
        };
      });
    });

    totalPriceUkv = Math.round(totalPriceUkv * 100) / 100;
    totalPriceBk = Math.round(totalPriceBk * 100) / 100;

    const tariffData: any = {
      productId: this.product,
      configuration,
      employersContribution: 0,
      totalPriceUkv,
      totalPriceBk
    };

    // tslint:disable-next-line:variable-name
    return new Promise((resolve, _reject) => {
      // tslint:disable-next-line:variable-name
      this.post('', tariffData).then((_result: any) => {
        resolve();
        // tslint:disable-next-line:variable-name
      }).catch((_e: any) => {
        resolve();
      });
    });
  }
}
